import { useState } from "react";

import { Container, BannerMsg } from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage.styles";
import { FormHS } from "~/features/selectionAssistant/heater/components/FormHS";
import { ResultHS } from "~/features/selectionAssistant/heater/components/ResultHS";
import { BannerHS } from "~/features/selectionAssistant/heater/components/BannerHS";
import { useTranslation } from "react-i18next";
import { useOnMount } from "~/common/hooks/useOnMount";
import { loadCartAmounts } from "~/features/addToCart/redux/cartAmounts/actions";
import { useDispatch } from "react-redux";
import { PurchasePlaceProvider, PurchaseTypeProvider } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import { Typography } from "~/common/mui";

export interface ResultsHeaterProps {
  imageUrl: string;
  mass: number;
  name: string;
  url: string;
}

interface HeaterSelectionAssistantViewProps {
  initialResult?: ResultsHeaterProps[] | null;
}

export function HeaterSelectionAssistantView({ initialResult = null }: HeaterSelectionAssistantViewProps) {
  const { t } = useTranslation();

  const [result, setResult] = useState<ResultsHeaterProps[] | null>(initialResult);

  function handleChange(newValue: ResultsHeaterProps[] | null) {
    setResult(newValue);
  }

  const dispatch = useDispatch();
  useOnMount(() => {
    dispatch(loadCartAmounts());
  });

  return (
    <Container tracking-aux-container="heater_selection_assistant">
      <Typography component={"h1"} variant={"headlineMedium"} sx={{ mb: 2 }}>
        {t("heaterSelectionAssistant.pageTitle")}
      </Typography>
      <Typography component={"h2"} variant={"headlineSmall"} sx={{ mb: 2 }}>
        {t("heaterSelectionAssistant.pageSubTitle")}
      </Typography>

      <FormHS handleChange={handleChange} />

      {result && (
        <div>
          <ResultHS data={result} />
        </div>
      )}

      <BannerMsg tracking-aux-banner="heater_selection_assistant_explore_now">
        <BannerHS />
      </BannerMsg>
    </Container>
  );
}

export function HeaterSelectionAssistant() {
  const dispatch = useDispatch();
  useOnMount(() => {
    dispatch(loadCartAmounts());
  });

  return <HeaterSelectionAssistantView />;
}

export function createHeaterSelectionAssistantComponent() {
  return (
    <PurchasePlaceProvider value={"HTSA"}>
      <PurchaseTypeProvider value={"htsa"}>
        <HeaterSelectionAssistant />
      </PurchaseTypeProvider>
    </PurchasePlaceProvider>
  );
}
